namespace RecordShield.Administration {
    export interface TenantDetailsRow {
        ID?: number;
        TenantId?: number;
        TenantName?: string;
        DisplayName?: string;
        Email?: string;
        UserId?: number;
        Mobile?: string;
        CreditBalance?: number;
        TotalProducts?: number;
        LastCreditsPurchased?: number;
        TotalCreditsPurchased?: number;
        PurchasedDate?: string;
        RegistrationDate?: string;
        PurchasedJournal?: string;
    }

    export namespace TenantDetailsRow {
        export const idProperty = 'TenantId';
        export const nameProperty = 'TenantName';
        export const localTextPrefix = 'Administration.TenantDetails';

        export namespace Fields {
            export declare const ID: string;
            export declare const TenantId: string;
            export declare const TenantName: string;
            export declare const DisplayName: string;
            export declare const Email: string;
            export declare const UserId: string;
            export declare const Mobile: string;
            export declare const CreditBalance: string;
            export declare const TotalProducts: string;
            export declare const LastCreditsPurchased: string;
            export declare const TotalCreditsPurchased: string;
            export declare const PurchasedDate: string;
            export declare const RegistrationDate: string;
            export declare const PurchasedJournal: string;
        }

        ['ID', 'TenantId', 'TenantName', 'DisplayName', 'Email', 'UserId', 'Mobile', 'CreditBalance', 'TotalProducts', 'LastCreditsPurchased', 'TotalCreditsPurchased', 'PurchasedDate', 'RegistrationDate', 'PurchasedJournal'].forEach(x => (<any>Fields)[x] = x);
    }
}
